module.exports = __webpack_public_path__ + "static/Sopot-72ebfdd5dddf6caccb7614e813756672.svg";